import React from 'react';
import { useTheme } from '../../theme';
import SectionLabel from '../shared/SectionLabel';

const steps = [
  { n: '01', t: 'Sign in with the platform', d: "Connect Xbox, PSN, Steam, or Discord. Whichever you used to use. We verify the username was actually yours, so impersonators stay out of the index." },
  { n: '02', t: 'File a tag for someone', d: 'Enter their old handle, the platform, and a short note. A memory, a year, a game. Smaller and more specific is better.' },
  { n: '03', t: 'Wait, or be waited for', d: 'When somebody searches their old name, your note appears. They decide whether to respond. We never message anyone for you.' },
];

export default function HowItWorks() {
  const { p, d, fonts } = useTheme();

  return (
    <section style={{ padding: `${d.hero}px ${d.pad}px`, borderBottom: `1px solid ${p.border}` }}>
      <div style={{ maxWidth: 1180, margin: '0 auto' }}>
        <SectionLabel>§ 01 / how it works</SectionLabel>
        <h2 style={{
          fontFamily: fonts.serif, fontSize: 56, fontWeight: 400, letterSpacing: '-.025em',
          lineHeight: 1.04, color: p.textHi, margin: '0 0 64px', maxWidth: 780,
        }}>
          Three steps. <span style={{ fontStyle: 'italic', color: p.text }}>No catch. No spam.</span>
        </h2>
        <div style={{
          display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 0,
          borderTop: `1px solid ${p.border}`, borderBottom: `1px solid ${p.border}`,
        }}>
          {steps.map((s, i) => (
            <div key={s.n} style={{
              padding: `32px ${d.gap + 8}px`,
              borderLeft: i > 0 ? `1px solid ${p.border}` : 'none',
            }}>
              <div style={{ fontFamily: fonts.mono, fontSize: 13, color: p.accent, letterSpacing: '.08em', marginBottom: 18 }}>
                STEP {s.n}
              </div>
              <div style={{
                fontFamily: fonts.serif, fontSize: 26, fontWeight: 500, color: p.textHi,
                letterSpacing: '-.015em', lineHeight: 1.2, marginBottom: 14,
              }}>
                {s.t}
              </div>
              <div style={{ fontFamily: fonts.sans, fontSize: 14.5, lineHeight: 1.6, color: p.text }}>
                {s.d}
              </div>
            </div>
          ))}
        </div>
      </div>

      <style>{`
        @media (max-width: 768px) {
          section > div > div:last-child { grid-template-columns: 1fr !important; }
          section > div > div:last-child > div { border-left: none !important; border-bottom: 1px solid rgba(255,255,255,.08); }
        }
      `}</style>
    </section>
  );
}
